import { render, staticRenderFns } from "./EditReceipt.vue?vue&type=template&id=dc1b7114&scoped=true&"
import script from "./EditReceipt.vue?vue&type=script&lang=js&"
export * from "./EditReceipt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc1b7114",
  null
  
)

export default component.exports